compiler('[submit-on-change]', (element) => {
  const targetSelector = element.getAttribute('submit-on-change')
  const target = document.querySelector(targetSelector)

  element.addEventListener('change', () => target.submit())
})